import { HomeTrackProgressV1 } from './HomeTrackProgress.v1';
import { HomeTrackProgressV2 } from './HomeTrackProgress.v2';
import { LabProcessSheet } from '@screens/HomePage/components/LabProcessSheet';
import { TrackingSampleModal } from '@screens/HomePage/components/TrackingSampleModal';
import { useGetTrackV3 } from '@viome/viome-base/src/usecase/Home/HomeV2Query';
import { useDynamicConfig } from '@statsig/react-bindings';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

interface HomeTrackProgressProps {
  screen: 'nornr' | 'retest';
}

export const HomeTrackProgress = ({ screen }: HomeTrackProgressProps) => {
  const enableNewTracker = useDynamicConfig('public_config').get(
    'enable_new_tracker',
    false,
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLabProcessOpen, setIsLabProcessOpen] = useState(false);
  // v3-only lab_process; gate the fetch on the new-tracker flag.
  const { data: testStatus } = useGetTrackV3({ enabled: enableNewTracker });

  useEffect(() => {
    if (searchParams.get('trackMySample') !== 'true') {
      return;
    }

    setIsModalOpen(true);

    const nextParams = new URLSearchParams(searchParams);
    nextParams.delete('trackMySample');
    setSearchParams(nextParams, { replace: true });
  }, [searchParams, setSearchParams]);

  return (
    <>
      {enableNewTracker ? (
        <HomeTrackProgressV2 screen={screen} />
      ) : (
        <HomeTrackProgressV1
          screen={screen}
          onOpenTracking={() => setIsModalOpen(true)}
        />
      )}
      <TrackingSampleModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onLearnMore={() => {
          setIsModalOpen(false);
          setIsLabProcessOpen(true);
        }}
      />
      {enableNewTracker && testStatus?.lab_process && (
        <LabProcessSheet
          labProcess={testStatus.lab_process}
          open={isLabProcessOpen}
          onOpenChange={setIsLabProcessOpen}
        />
      )}
    </>
  );
};
